import { formatHtml } from "@trumpf/ux.common-storybook";
import { SuccessStoriesHeroSliderTemplate } from "./success-stories-slider.templates";

export default {
    title: "Website/Partial Templates/Success Stories Hero Slider",
    render: SuccessStoriesHeroSliderTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
};

export const Default = {};
